module.exports = "https://static.wmbcdn.com/uniweb/images/9d69a29a6d64fe2c1b6e4f7ab428cf3d.png";